(() => {
  async function init(root) {
    if (root.dataset.ready || !window.TexanShopping) return;
    root.dataset.ready = 'true';
    const S = window.TexanShopping;
    const config = JSON.parse(root.querySelector('[data-bundle-config]').textContent);
    const T = config.text;
    const route = root.dataset.root || '/';
    const controls = {};
    for (const key of ['size', 'mattress', 'base', 'bedding']) controls[key] = root.querySelector('[data-bundle-' + key + ']');
    const state = { mattress: null, base: null, bedding: null, package: null, items: [], sequence: 0, adding: false };
    const button = root.querySelector('[data-bundle-add]');
    const status = root.querySelector('[data-bundle-status]');
    const params = new URLSearchParams(location.search);
    const preset = params.get('mattress');
    const presetId = params.get('variant');
    function addOptions(select, products) {
      products.forEach(product => { const option = S.node('option', product.title); option.value = product.handle; select.appendChild(option); });
    }
    const unique = products => products.filter((product, index) => products.findIndex(item => item.handle === product.handle) === index);
    config.mattresses = unique([...config.mattresses, ...config.sets.map(set => ({ handle: set.mattressHandle, title: set.title.replace(/ Adjustable Bed Set| Bed Set/g, '') }))]);
    config.bases = unique([...config.bases, ...config.sets.map(set => ({ handle: set.baseHandle, title: set.baseName }))]);
    const tierNames = {'btx4-adjustable-base':'Good · BTX4','bt3000-adjustable-base':'Better · BT3000','bt6500-adjustable-base':'Best · BT6500'};
    const tierOrder = handle => Object.keys(tierNames).includes(handle) ? Object.keys(tierNames).indexOf(handle) : 3;
    config.bases.sort((a,b) => tierOrder(a.handle) - tierOrder(b.handle));
    config.bases.forEach(base => { if (tierNames[base.handle]) base.title = tierNames[base.handle]; });
    const tierButtons = [...root.querySelectorAll('[data-bundle-base-tier]')];
    addOptions(controls.mattress, config.mattresses);
    addOptions(controls.bedding, config.bedding);
    const requestedSize = S.size(params.get('size')); if (requestedSize) controls.size.value = requestedSize;
    function message(text, error = false) { status.textContent = text; status.setAttribute('role', error ? 'alert' : 'status'); }
    function showOptions(key) {
      const selection = state[key];
      const container = root.querySelector('[data-bundle-' + key + '-options]');
      container.replaceChildren();
      if (!selection?.variant) return;
      S.options(container, selection.product, selection.list.variants, selection.variant, variant => {
        selection.variant = variant;
        refresh(false);
      }, 'tx-bundle-option-' + key);
    }
    async function selection(key, allowPair) {
      const handle = controls[key].value;
      if (!handle) { state[key] = null; return null; }
      const product = await S.load(route, handle);
      const list = S.candidates(product, controls.size.value, allowPair);
      const previous = state[key]?.product.handle === handle ? [...(state[key].variant?.options || [])] : [];
      if (list.index >= 0) previous[list.index] = null;
      const variant = S.choose(list.variants, previous);
      return { product, list, variant, quantity: list.quantity };
    }
    let defaultedMattressHandle = null;
    function baseChoices() {
      const old = controls.base.value;
      controls.base.replaceChildren();
      const none = S.node('option', T.none_base); none.value = ''; controls.base.appendChild(none);
      const product = state.mattress?.product;
      const allowed = product?.compatible === true ? config.bases : config.bases.filter(base => config.sets.some(set => set.mattressHandle === product?.handle && set.baseHandle === base.handle));
      addOptions(controls.base, allowed);
      const isNewMattress = product?.handle !== defaultedMattressHandle;
      controls.base.value = allowed.some(base => base.handle === old) ? old : isNewMattress && allowed.some(base => base.handle === 'bt3000-adjustable-base') ? 'bt3000-adjustable-base' : '';
      defaultedMattressHandle = product?.handle || null;
      controls.base.disabled = !product || !allowed.length;
      root.querySelector('[data-bundle-base-status]').textContent = product && !allowed.length ? T.compatibility : '';
    }
    async function updateTierButtons(sequence) {
      await Promise.all(tierButtons.map(async tierButton => {
        const handle = tierButton.dataset.bundleBaseTier;
        const allowed = [...controls.base.options].some(option => option.value === handle);
        let available = false;
        try {
          if (allowed && state.mattress?.variant) {
            const base = await S.load(route,handle);
            available = S.candidates(base,controls.size.value,true).variants.some(variant => variant.available);
          }
        } catch (_) {}
        if (sequence !== state.sequence) return;
        tierButton.disabled = !available;
        tierButton.setAttribute('aria-pressed',String(controls.base.value === handle));
      }));
    }
    function setVariant(set, selected, selectedSize) {
      const list = S.candidates(set, selectedSize, false);
      const sourceValues = selected.variant.options.filter((value, index) => index !== selected.list.index).map(value => String(value).toLowerCase().trim());
      const exact = list.variants.find(variant => variant.available && variant.options.every((value, index) => index === list.index || set.options[index].values.length === 1 || sourceValues.includes(String(value).toLowerCase().trim())));
      return exact || null;
    }
    async function packagePrice(mattress, base, selectedSize) {
      if (!mattress?.variant || !base?.variant) return null;
      const match = config.sets.find(set => set.mattressHandle === mattress.product.handle && set.baseHandle === base.product.handle);
      if (!match) return null;
      const product = await S.load(route, match.handle);
      const mapping = (window.TexanBundleVariantMap || {})[match.handle] || [];
      const linked = mapping.find(row => String(row[1]) === String(mattress.variant.id) && S.size(row[2]) === selectedSize);
      const variant = linked ? product.variants.find(item => String(item.id) === String(linked[0]) && item.available) : setVariant(product, mattress, selectedSize);
      return variant ? { product, variant, quantity: 1 } : null;
    }
    function draw() {
      const list = root.querySelector('[data-bundle-items]'); list.replaceChildren();
      const image = root.querySelector('[data-bundle-image]');
      image.hidden = !state.mattress?.product.image;
      if (!image.hidden) { image.src = state.mattress.product.image; image.alt = state.mattress.product.title; }
      const chosen = state.package ? [state.package, state.bedding].filter(Boolean) : [state.mattress, state.base, state.bedding].filter(Boolean);
      let valid = Boolean(state.mattress?.variant?.available);
      let total = 0, compare = 0;
      const items = [];
      for (const selection of chosen) {
        if (!selection.variant?.available) { valid = false; continue; }
        const quantity = selection.quantity;
        items.push({ id: selection.variant.id, quantity });
        const price = selection.variant.price * quantity;
        total += price; compare += Math.max(selection.variant.compareAt, selection.variant.price) * quantity;
        const li = S.node('li');
        const copy = S.node('span', (quantity === 2 ? T.pair + ' · ' : '') + selection.product.title);
        copy.appendChild(S.node('small', selection.variant.title));
        const amount = S.node('strong', S.money(price, selection.product.currency));
        li.append(copy, amount); list.appendChild(li);
      }
      state.items = items;
      const currency = state.mattress?.product.currency || 'USD';
      root.querySelector('[data-bundle-total]').textContent = state.mattress?.variant ? S.money(total, currency) : '—';
      const savings = root.querySelector('[data-bundle-savings]'); savings.hidden = compare <= total;
      savings.textContent = T.save + ': ' + S.money(Math.max(0, compare - total), currency);
      const packageNode = root.querySelector('[data-bundle-package]'); packageNode.replaceChildren(); packageNode.hidden = !state.base;
      if (state.package) {
        packageNode.appendChild(S.node('span', T.package));
        const link = S.node('a', state.package.product.title); link.href = S.link(state.package.product, state.package.variant); link.style.display = 'block';
        packageNode.appendChild(link);
      } else if (state.base) packageNode.textContent = T.standalone;
      for (const key of ['mattress', 'base', 'bedding']) {
        const selection = state[key]; const hint = root.querySelector('[data-bundle-' + key + '-status]');
        if (!selection) continue;
        hint.textContent = !selection.variant ? (key === 'mattress' ? T.no_size : key === 'base' ? T.no_base_size : T.bedding_size) : !selection.variant.available ? T.unavailable : '';
        if (!selection.variant?.available) valid = false;
      }
      button.disabled = !valid || state.adding;
      if (valid) message(''); else message(state.mattress ? (!state.mattress.variant ? T.no_size : T.unavailable) : T.choose);
      for (const key of ['mattress', 'base', 'bedding']) showOptions(key);
    }
    async function refresh(loadSelections = true) {
      const sequence = ++state.sequence;
      button.disabled = true;
      root.setAttribute('aria-busy', 'true'); message(T.loading);
      try {
        if (loadSelections) {
          const mattress = await selection('mattress', true);
          if (sequence !== state.sequence) return;
          state.mattress = mattress; baseChoices();
          controls.bedding.disabled = !mattressAvailable();
          const [base, bedding] = await Promise.all([selection('base', true), selection('bedding', false)]);
          if (sequence !== state.sequence) return;
          state.base = base; state.bedding = bedding;
        }
        const pricedPackage = await packagePrice(state.mattress, state.base, controls.size.value);
        if (sequence !== state.sequence) return;
        state.package = pricedPackage;
        root.setAttribute('aria-busy', 'false'); draw(); updateTierButtons(sequence);
      } catch (error) {
        if (sequence !== state.sequence) return;
        root.setAttribute('aria-busy', 'false'); message(T.error, true); button.disabled = true;
      }
    }
    function mattressAvailable() { return Boolean(state.mattress?.variant?.available); }
    controls.size.addEventListener('change', () => refresh());
    controls.mattress.addEventListener('change', () => { controls.base.value = ''; state.mattress = null; refresh(); });
    controls.base.addEventListener('change', () => refresh());
    tierButtons.forEach(tierButton => tierButton.addEventListener('click',() => { controls.base.value = tierButton.dataset.bundleBaseTier; refresh(); }));
    controls.bedding.addEventListener('change', () => refresh());
    button.addEventListener('click', async () => {
      if (button.disabled || state.adding || !state.items.length) return;
      state.adding = true; button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = T.adding; message(T.adding);
      try {
        const response = await fetch(root.dataset.addUrl.replace(/\.js$/, '') + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: state.items }) });
        const result = await response.json(); if (!response.ok) throw new Error(result.description || T.cart_error);
        location.assign(root.dataset.cartUrl);
      } catch (error) {
        state.adding = false; button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = T.cta; message(error.message || T.cart_error, true);
      }
    });
    if (preset) {
      try {
        const product = await S.load(route, preset);
        if (!config.mattresses.some(item => item.handle === preset)) addOptions(controls.mattress, [product]);
        controls.mattress.value = preset;
        const variant = product.variants.find(item => String(item.id) === presetId);
        if (variant) {
          const index = S.sizeIndex(product); const selectedSize = S.size(variant.options[index]);
          if (selectedSize) controls.size.value = selectedSize;
          state.mattress = { product, variant };
        }
        refresh();
      } catch (error) { message(T.error, true); }
    }
  }
  const boot = () => document.querySelectorAll('[data-tx-guided-bundle]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
